import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {combineLatest} from "rxjs";
import * as fromStore from "../store";
import {Store} from "@ngrx/store";
import {UserManagementService} from "./user-management.service";
import {filter, first, switchMap} from "rxjs/operators";

@Injectable()
export class UserManagementResolver implements Resolve<any|null> {

  workspaceClients: any[] = [];
  workspaceName: string = '';

  constructor(
    private _store: Store<fromStore.DbStoreState>,
    private _userManagementService: UserManagementService
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>|Promise<any>|any {
    return new Promise((resolve: Function, reject: Function): void => {
      this._store.select(fromStore.getWorkspaceLoaded)
        .pipe(
          filter(loaded => loaded),
          switchMap(() => combineLatest(
            this._store.select(fromStore.getWorkspaceAllClients),
            this._store.select(fromStore.getOwnerWorkspace)
          )),
          first()
        )
        .subscribe( ([clients, ownerWorkspace]) => {
          this.workspaceClients = clients;
          this.workspaceName = ownerWorkspace && ownerWorkspace.workspaceName;
          resolve({workspaceClients: this.workspaceClients, workspaceName: this.workspaceName});
        });
    });
  }
}
